import { getJsonAsync } from '@digabi/fetch'
import { tokenUtils } from './token-utils'
import type { AwsSecurityFinding, SecurityAlert } from '../../types'

function withAuth<T>(url: string) {
  return getJsonAsync<T>(url, {
    headers: {
      Authorization: `Bearer ${tokenUtils.getValidToken()}`,
    },
  })
}

export const getSecurityAlerts = () => withAuth<SecurityAlert[]>('/api/security-alerts')
export const getAwsSecurityFindings = () => withAuth<AwsSecurityFinding[]>('/api/aws-security-findings')
